import React from "react";
import { ArrowDown, Play } from "lucide-react";
import { useLanguage } from "../context/LanguageContext";

const HERO_IMG =
  "https://static.wixstatic.com/media/952455_bae97b424d8e486d91f831f4ac833568f000.jpg/v1/fill/w_1920,h_1080,al_c,q_90/file.jpg";
const HERO_FALLBACK =
  "https://images.unsplash.com/photo-1507676184212-d03ab07a01bf?auto=format&fit=crop&w=1920&q=80";

export const Hero = () => {
  const { t } = useLanguage();

  return (
    <section
      data-testid="hero-section"
      id="home"
      className="relative min-h-screen w-full overflow-hidden grain"
    >
      <div className="absolute inset-0">
        <img
          src={HERO_IMG}
          onError={(e) => (e.currentTarget.src = HERO_FALLBACK)}
          alt="Proscenio Ensemble"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 hero-overlay" />
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-12 min-h-screen flex flex-col justify-end pb-24 pt-40">
        <div className="max-w-3xl">
          <div className="overline reveal reveal-delay-1" data-testid="hero-overline">
            {t.hero.overline}
          </div>

          <h1
            data-testid="hero-title"
            className="font-serif-display font-light text-white leading-[0.95] tracking-tighter mt-6 reveal reveal-delay-2 text-6xl sm:text-7xl lg:text-8xl xl:text-[9rem]"
          >
            {t.hero.title}
            <br />
            <span className="italic font-serif-bodoni text-[#D4AF37]">
              {t.hero.titleAccent}
            </span>
          </h1>

          <p
            data-testid="hero-subtitle"
            className="mt-8 text-lg sm:text-xl text-[#D1D1D1] font-light max-w-xl leading-relaxed reveal reveal-delay-3"
          >
            {t.hero.subtitle}
          </p>

          <div className="mt-10 flex flex-wrap items-center gap-5 reveal reveal-delay-4">
            <button
              data-testid="hero-cta-primary"
              onClick={() =>
                document
                  .getElementById("about")
                  ?.scrollIntoView({ behavior: "smooth" })
              }
              className="group inline-flex items-center gap-3 bg-[#D4AF37] hover:bg-[#E8C85F] text-black px-8 py-4 text-sm tracking-[0.2em] uppercase font-medium transition-all duration-300"
            >
              {t.hero.cta}
              <ArrowDown
                size={16}
                className="group-hover:translate-y-0.5 transition-transform"
              />
            </button>

            <button
              data-testid="hero-cta-secondary"
              onClick={() =>
                document
                  .getElementById("discography")
                  ?.scrollIntoView({ behavior: "smooth" })
              }
              className="group inline-flex items-center gap-3 border border-[#D4AF37] hover:bg-[#D4AF37]/10 text-[#D4AF37] px-8 py-4 text-sm tracking-[0.2em] uppercase font-medium transition-all duration-300"
            >
              <Play size={14} className="fill-[#D4AF37]" />
              {t.hero.ctaSecondary}
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
